/**
 * PURPOSE: Consumir las herramientas transaccionales del tab Fases.
 * RESPONSIBILITIES: Cargar contexto y ejecutar altas de participantes, partidos y posiciones.
 * COLLABORATORS: FasesArea.jsx y backend /phase-tools.
 * ROUTE: winscore/src/services/phaseToolsService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

const scope = (idevent, idsport) => ({
  idevent: Number(idevent),
  idsport: Number(idsport),
});

export const getPhaseToolsContext = async ({ idevent, idsport }) => {
  const response = await axios.post(`${API_BASE_URL}/phase-tools/context`, {
    ...scope(idevent, idsport),
  });
  return response.data;
};

export const addPhaseParticipants = async ({
  idevent,
  idsport,
  institutionIds,
}) => {
  const response = await axios.post(`${API_BASE_URL}/phase-tools/participants`, {
    ...scope(idevent, idsport),
    institutionIds: institutionIds.map(Number),
  });
  return response.data;
};

export const deletePhaseParticipant = async ({
  idevent,
  idsport,
  idparticipant,
}) => {
  const response = await axios.delete(
    `${API_BASE_URL}/phase-tools/participants/${Number(idparticipant)}`,
    {
      data: scope(idevent, idsport),
    }
  );
  return response.data;
};

export const createPhaseMatches = async ({ idevent, idsport, matches }) => {
  const response = await axios.post(`${API_BASE_URL}/phase-tools/matches`, {
    ...scope(idevent, idsport),
    matches,
  });
  return response.data;
};

export const recreatePhasePositions = async ({ idevent, idsport }) => {
  const response = await axios.post(`${API_BASE_URL}/phase-tools/positions`, {
    ...scope(idevent, idsport),
  });
  return response.data;
};

export const updatePhaseGroups = async ({
  idevent,
  idsport,
  nro_grupos,
}) => {
  const response = await axios.patch(
    `${API_BASE_URL}/phase-tools/config/groups`,
    {
      ...scope(idevent, idsport),
      nro_grupos: Number(nro_grupos),
    }
  );
  return response.data;
};
